export default class Menu {
    constructor(node) {
        this.node = node

        this.prevScrollpos = 0
        this.scrollMenuBehaviour = this.scrollMenuBehaviour.bind(this)

        this.init()
    }

    init() {
        // console.debug('  -> Menu init')
        this.addListeners()
        this.scrollMenuBehaviour()
    }

    addListeners() {
        window.addEventListener('scroll', this.scrollMenuBehaviour)
    }

    scrollMenuBehaviour() {
        var currentScrollPos = window.scrollY
        
        if( this.prevScrollpos > currentScrollPos ){
            if( currentScrollPos == 0 ){
                this.node.classList.add('top')
                this.node.style.transform = 'translateY(0)'
            } else {
                this.node.classList.remove('top')
            }
        } else if( currentScrollPos > 0 ){
            this.node.style.transform = 'translateY(-82px)'
            this.node.classList.remove('top')
        } else if( currentScrollPos > 0 && this.node.classList.contains('top') ){
            this.node.classList.remove('top')
        } else if( currentScrollPos == 0 ){
            this.node.classList.add('top')
        }

        this.prevScrollpos = currentScrollPos
    }

    static destroy() {
        // console.debug('  -> Menu destroy')
    }

    static init() {
        // console.debug('== Menu component ==')
        Menu.item = new Menu(document.querySelector('.header'))
    }
}
